import React from 'react';
export function Footer() {
  return <footer className="bg-black text-gray-400 py-12 px-4 border-t border-zinc-900 text-center" data-id="element-62">
      <div className="max-w-4xl mx-auto" data-id="element-63">
        <div className="font-display font-black text-2xl text-white mb-4" data-id="element-64">
          🥗 BIBLIOTECAPRO™
        </div>
        <p className="mb-8 max-w-md mx-auto" data-id="element-65">
          El sistema N°1 para nutricionistas en Argentina. Porque ejercer la
          nutrición no debería costarte todos los domingos del año.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-12 text-sm" data-id="element-66">
          <a href="mailto:bibliotecapro2026@gmail.com" className="hover:text-brand transition-colors" data-id="element-67">
            📧 bibliotecapro2026@gmail.com
          </a>
          <span className="hidden md:inline" data-id="element-68">•</span>
          <span className="hover:text-brand transition-colors cursor-pointer" data-id="element-69">
            📲 @bibliotecapro
          </span>
          <span className="hidden md:inline" data-id="element-70">•</span>
          <a href="https://www.bibliotecapro.online" className="hover:text-brand transition-colors" data-id="element-71">
            🌐 www.bibliotecapro.online
          </a>
        </div>

        <div className="text-xs text-zinc-600" data-id="element-72">
          © BibliotecaPro™ 2026 — Todos los derechos reservados
        </div>
      </div>
    </footer>;
}